import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="bg-accent-500">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-primary-950 leading-tight">
              有些事，只有你说出来才会被看见
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-primary-900">
              不必署名，不必解释你是谁。把你掌握的那部分事实交给爆料51，剩下的事情由我们按保密机制处理。
            </p>
          </div>
          <Link
            to="/submit"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md text-sm font-medium whitespace-nowrap bg-primary-950 text-background-50 hover:bg-primary-900 transition-colors cursor-pointer"
          >
            <i className="ri-lock-2-line" aria-hidden="true"></i>
            进入匿名投稿通道
          </Link>
        </div>
      </div>
    </section>
  );
}